export const CaseQuizForms = {
  namespaced: true,

  state: {
    forms: [],
    pagination: {},
    saving: false,
    loading: false,
    userCanAddForms: false,
    answersConfiguration: null,
  },

  getters: {
    getQuizForms: (state) => () => {
      return state.forms ?? [];
    },

    areFormsLoaded: (state) => () => {
      return Object.keys(state.forms).length;
    },

    areFormsLoading: (state) => state.loading,

    getPaginationData:
      ({ pagination }) =>
      () =>
        pagination ?? {},

    answersConfiguration: (state) => state.answersConfiguration,
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },

    setSaving(state, saving) {
      state.saving = saving;
    },

    setPagination(state, pagination) {
      state.pagination = { ...state.pagination, ...pagination };
    },

    updateQuizForms(state, newForms) {
      state.forms = newForms;
    },

    setAnswersConfiguration(state, data) {
      state.answersConfiguration = data;
    },

    resetAnswersConfiguration(state) {
      state.answersConfiguration = null;
    },
  },

  actions: {
    async loadQuizForms({ commit }, { filters, page = 1, limit }) {
      let forms = [];
      let pagination = {};

      if (filters) {
        filters = filters.filter(function (fil) {
          if (fil.value.length !== 0) return fil;
        });
      }

      commit('setLoading', true);

      try {
        const response = await this._vm.$api('users.current.forms.index', {
          version: '1.0',
          filters,
          limit,
          page,
        });
        forms = response?.data.data;
        pagination = { ...response?.data.meta, ...response?.data.links };
      } catch (err) {
        console.error(err);
      }
      commit('updateQuizForms', forms);
      commit('setPagination', pagination);

      commit('setLoading', false);
    },

    async createQuizForm({ commit, dispatch }, { form }) {
      const name = form.name;
      const description = form.description;

      commit('setSaving', true);

      await this._vm.$api(
        'forms.store',
        {
          version: '1.0',
        },
        {
          name: name,
          description: description,
        }
      );

      await dispatch('loadQuizForms', {});
      commit('setSaving', false);
    },

    async updateQuizForm({ commit, dispatch }, { form, newData }) {
      const name = newData.name;
      const description = newData.description;

      commit('setSaving', true);

      await this._vm.$api(
        'forms.update',
        {
          version: '1.0',
          form: form.uuid,
        },
        {
          name,
          description,
        }
      );

      await dispatch('loadQuizForms', {});
      commit('setSaving', false);
    },

    async deleteForm({ commit, dispatch }, { form, comment }) {
      commit('setSaving', true);

      await this._vm.$api(
        'forms.destroy',
        {
          version: '1.0',
          form: form,
        },
        { comment }
      );

      await dispatch('loadQuizForms', {});
      commit('setSaving', false);
    },

    updateQuizForms({ commit }, forms) {
      commit('updateQuizForms', forms);
    },
  },
};
